import { render } from "./carrinho.vue?vue&type=template&id=7ed5af9a"
import script from "./carrinho.vue?vue&type=script&lang=js"
export * from "./carrinho.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__